import { combineReducers } from 'redux-immutable'
import { State } from '../constant/initState'
import { handleActions } from 'redux-actions';
import JWTManager from "../constant/JWTManager"
// import cookie from 'react-cookies'
import { 
  FETCH_LATEST_UNION_DATA,
  FETCH_PERIOD_DATA,
  FETCH_PERIOD_PLAYER_DATA,
  FETCH_MULTI_PERIOD_PLAYER_DATA,
  FETCH_CLUBS_FOR_UNION,
  FETCH_AGENTS_FOR_CLUB,
  FETCH_SUBAGENTS_FOR_AGENT,
  FETCH_CHART_DATA,
  FETCH_MULTI_PERIOD_DATA,
  SEARCH_ENTITY,
  RESET_WEEKLY_TOTAL_WIN_DATA,
} from '../action/userAction';

// Add initial fetch status to State
const initialState = {
  ...State,
  fetch_status: {
    status: 'idle', // 'idle', 'loading', 'success', 'failed'
    action: null,
    error: null
  }
};

const dataReducer = handleActions({
  // Add fetch status actions
  FETCH_START: (state, { payload }) => {
    return {
      ...state,
      fetch_status: {
        status: 'loading',
        action: payload.action,
        error: null
      }
    };
  },

  FETCH_SUCCESS: (state, { payload }) => {
    return {
      ...state,
      fetch_status: {
        status: 'success',
        action: payload.action,
        error: null
      }
    };
  },

  FETCH_FAILURE: (state, { payload }) => {
    return {
      ...state,
      fetch_status: {
        status: 'failed',
        action: payload.action,
        error: payload.error
      }
    };
  },

  LOGIN_SUCCESS: (state, { payload }) => {
    // Handle the new token format with expiration
    JWTManager.setToken(payload);
    
    return { 
      ...state, 
      login: true, 
      access_token: payload.access_token, 
      refresh_token: payload.refresh_token,
      token_expiry: payload.expires_in ? new Date().getTime() + (payload.expires_in * 1000) : null,
      loginError: null // Clear any previous login errors
    };
  },
  
  LOGIN_FAILED: (state, { payload }) => {
    // Clear tokens from JWTManager on login failure
    JWTManager.clearToken();
    
    return { 
      ...initialState, 
      login: false, 
      loginError: payload.errormsg || 'Authentication failed' 
    };
  },
  
  LOGIN_RESET: (state, { payload }) => {
    // Clear tokens from JWTManager
    JWTManager.clearToken();
    
    return { ...initialState };
  },
  
  LOGOUT: (state) => {
    // Clear tokens from JWTManager
    JWTManager.clearToken();
    
    let new_state = {...state};
    delete new_state.access_token;
    delete new_state.refresh_token;
    delete new_state.token_expiry;
    delete new_state.user;
    
    return {
      ...new_state, 
      login: false
    };
  },
  
  TOKEN_REFRESHED: (state, { payload }) => {
    // Update just the access token and expiry time
    JWTManager.updateAccessToken(payload.access_token, payload.expires_in);
    
    return {
      ...state,
      access_token: payload.access_token,
      token_expiry: payload.expires_in ? new Date().getTime() + (payload.expires_in * 1000) : null
    };
  },
  
  AUTH_ERROR: (state, { payload }) => {
    // Handle authentication errors - reset auth state
    JWTManager.clearToken();
    
    let new_state = {...state};
    delete new_state.access_token;
    delete new_state.refresh_token;
    delete new_state.token_expiry;
    delete new_state.user;
    
    return {
      ...new_state,
      login: false,
      authError: payload.error || 'Authentication error'
    };
  },
  
  // Existing action handlers
  SAVE_MEMBER: (state, { payload }) => {
    return { ...state, members: payload.members };
  },
  
  SAVE_UPLOADED_FILE: (state, { payload }) => {
    return { ...state, uploaded_files: payload.files };
  },
  
  // In the reducer
  SAVE_FILE_INFO: (state, { payload }) => {
    return { 
      ...state, 
      file_info: payload.file_info,
      pagination: {
        total: payload.total,
        page: payload.page,
        total_pages: payload.total_pages
      }
    };
  },
  
  SAVE_CLUB_INFO: (state, { payload }) => {
    return { ...state, club_info: payload.club_info };
  },
  
  SAVE_UNION_INFO: (state, { payload }) => {
    return { ...state, union_info: payload.union_info };
  },
  
  SAVE_REVENUE: (state, { payload }) => {
    return { ...state, revenue: payload.revenue };
  },

  SAVE_R2H_REVENUE: (state, { payload }) => {
    return { ...state, r2h_revenue: payload.r2h_revenue, cm_detail: payload.cm_detail };
  },
  
  SAVE_UNIONS_FEE: (state, { payload }) => {
    return { 
      ...state, 
      unions_fee: payload.unions_fee,  
      unions_col: payload.unions_col, 
      main_club: payload.main_club
    };
  },
  
  SAVE_GAMES_FEE: (state, { payload }) => {
    return { ...state, games_fee: payload.games_fee, games_col: payload.games_col };
  },
  
  SAVE_GENERAL_REPORT_STATUS: (state, { payload }) => {
    return { ...state, general_report_status: payload.status };
  },
  
  SAVE_SUPERAGENTS_FEE: (state, { payload }) => {
    return { 
      ...state, 
      super_agents: payload.super_agents, 
      super_agents_fee: payload.super_agents_fee 
    };
  },
  
  SAVE_JSON_WARNING: (state, { payload }) => {
    return { ...state, json_warning: payload.json_warning };
  },
  
  SAVE_MEMBERSHIP_SUM: (state, { payload }) => {
    return { 
      ...state, 
      membership_header: payload.membership_header, 
      membership_sum: payload.membership_sum 
    };
  },
  
  SAVE_UNION_MEMBERSHIP: (state, { payload }) => {
    return { ...state, union_membership_amount: payload.union_membership_amount };
  },
  
  SAVE_USER: (state, { payload }) => {
    return { ...state, user: payload.user };
  },
  
  SAVE_WEEKLY_TOTAL_PAY: (state, { payload }) => {
    return { 
      ...state, 
      weekly_total_pay: payload.data, 
      weekly_total_pay_error: null 
    };
  },

  SAVE_WEEKLY_TOTAL_WIN: (state, { payload }) => {
    return { 
      ...state, 
      weekly_total_win: payload.data, 
      weekly_total_win_error: null 
    };
  },

  SAVE_SERVER_CONFIG: (state, { payload }) => {
    return { ...state, config: payload.config };
  },
  
  
  WEEKLY_TOTAL_PAY_FAILED: (state, { payload }) => {
    return { 
      ...state, 
      weekly_total_pay: null, 
      weekly_total_pay_error: payload?.msg || "Failed to load data" 
    };
  },

  WEEKLY_TOTAL_WIN_FAILED: (state, { payload }) => {
    return { 
      ...state, 
      weekly_total_win: null, 
      weekly_total_win_error: payload?.msg || "Failed to load data" 
    };
  },

  // WeeklyTotalWin lazy loading reducer cases
  [FETCH_LATEST_UNION_DATA]: (state, { payload }) => {
    return { 
      ...state, 
      weekly_total_win: payload.data.weekly_total_win, 
      weekly_total_win_periods: payload.data.periods || [],
      weekly_total_win_currentPeriodIndex: payload.data.currentPeriodIndex || 0,
      weekly_total_win_error: null 
    };
  },
  
  [FETCH_PERIOD_DATA]: (state, { payload }) => {
    return { 
      ...state, 
      weekly_total_win: payload.data.weekly_total_win,
      weekly_total_win_currentPeriodIndex: payload.data.currentPeriodIndex,
      weekly_total_win_error: null 
    };
  },

  [FETCH_PERIOD_PLAYER_DATA]: (state, { payload }) => {
    return { 
      ...state, 
      weekly_total_player_win: payload.data.weekly_total_player_win,
      weekly_total_win_currentPeriodIndex: payload.data.currentPeriodIndex,
      weekly_total_win_error: null ,
      weekly_total_player_count: payload.data.weekly_total_player_count,
      weekly_total_player_sum: payload.data.weekly_total_player_sum
    };
  },

  [FETCH_MULTI_PERIOD_PLAYER_DATA]: (state, { payload }) => {
    return { 
      ...state, 
      weekly_total_player_win: payload.data.weekly_total_player_win,
      weekly_total_win_currentPeriodIndex: payload.data.currentPeriodIndex,
      weekly_total_win_error: null ,
      weekly_total_player_count: payload.data.weekly_total_player_count,
      weekly_total_player_sum: payload.data.weekly_total_player_sum
    };
  },
  
  [FETCH_CHART_DATA]: (state, { payload }) => {
    return { 
      ...state,
      weekly_total_win_chartData: payload.data.chartData,
      weekly_total_win_error: null 
    };
  },

  [FETCH_MULTI_PERIOD_DATA]: (state, { payload }) => {
    return { 
      ...state, 
      weekly_total_win_sum: payload.data.weekly_total_win,
      weekly_total_win_multi_periods_sum: payload.data.periods || [],
      weekly_total_win_multi_range_sum: payload.data.periodRange || [0, 0],
      weekly_total_win_error: null 
    };
  },

  [SEARCH_ENTITY]: (state, { payload }) => {
    if (payload.code === 1) {
      const { hierarchyPath, data } = payload.data;
      
      // Create a new state with updated hierarchy and search results
      const newState = {
        ...state,
        weekly_total_win_searchResults: data,  // Store search results
        weekly_total_win_error: null,
        // Update hierarchy state
        weekly_total_win_hierarchyLevel: hierarchyPath.level,
        weekly_total_win_currentUnionId: hierarchyPath.unionId,
        weekly_total_win_currentClubId: hierarchyPath.clubId,
        weekly_total_win_currentAgentId: hierarchyPath.agentId,
        // Add trigger and path for data loading
        weekly_total_win_triggerLoadData: true,
        weekly_total_win_hierarchyPath: hierarchyPath
      };
      
      return newState;
    }
    return state;
  },

  CLEAR_MULTI_PERIOD_DATA: (state) => {
    return {
      ...state,
      weekly_total_win_sum: null,
      weekly_total_win_multi_periods_sum: [],
      weekly_total_win_multi_range_sum: [0, 0],
      weekly_total_win_error: null
    };
  },  

  SAVE_FLASH_LEVEL_DATA: (state, { payload }) => {
    return { ...state, flash_level_col: payload.flash_level_col, flash_level_data: payload.flash_level_data };
  },

  FLASH_LEVEL_DATA_FAILED: (state, { payload }) => {
    return { ...state, flash_level_data: null, flash_level_data_error: payload?.msg || "Failed to load data" };
  },

  SAVE_AGENT_TAX_EVENT_LIST: (state, { payload }) => {
    return { ...state, agent_tax_event_list: payload.data || [] };
  },

  AGENT_TAX_EVENT_LIST_FAILED: (state, { payload }) => {
    return { ...state, agent_tax_event_list: [], agent_tax_event_list_error: payload?.msg || "Failed to load agent tax event list" };
  },

  [RESET_WEEKLY_TOTAL_WIN_DATA]: (state) => {
    return {
      ...state,
      weekly_total_win_sum: null,
      weekly_total_win_multi_periods_sum: [],
      weekly_total_win_multi_range_sum: [0, 0],
      weekly_total_win_error: null,
      // Reset other related data
      weekly_total_player_win: null,
      weekly_total_win_chartData: null,
      weekly_total_win_triggerLoadData: false,
      weekly_total_win_hierarchyPath: null,
      weekly_total_win_searchResults: null
    };
  },

}, initialState);

const rootReducer = combineReducers({
  data: dataReducer
});

export default rootReducer;